import React, { forwardRef } from "react";
import QuillEditor from "./QuillEditor";

// Editor component using React-Quill instead of Froala
// This maintains the same API for backward compatibility
const Editor = forwardRef(({ readOnly, defaultValue, onTextChange, onSelectionChange }, ref) => {
  return (
    <QuillEditor
      ref={ref}
      readOnly={readOnly}
      defaultValue={defaultValue}
      onTextChange={onTextChange}
      onSelectionChange={onSelectionChange}
    />
  );
});

Editor.displayName = "Editor";

export default Editor;
